import type { InventoryCategoryRecord } from '@/renderer/types/inventory';
import { Button, DropdownSelect, Input } from '@components/common';

interface InventoryItemsToolbarProps {
  searchQuery: string;
  categoryFilter: string;
  statusFilter: 'all' | 'active' | 'inactive';
  categories: InventoryCategoryRecord[];
  onSearchChange: (value: string | number) => void;
  onCategoryChange: (value: string) => void;
  onStatusChange: (value: 'all' | 'active' | 'inactive') => void;
  onCreate: () => void;
}

export function InventoryItemsToolbar({
  searchQuery,
  categoryFilter,
  statusFilter,
  categories,
  onSearchChange,
  onCategoryChange,
  onStatusChange,
  onCreate,
}: InventoryItemsToolbarProps) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">
            Inventory items
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            Manage company-wide stock items, inline units, conversion rules, and
            reorder levels.
          </p>
        </div>
        <Button onClick={onCreate}>Create item</Button>
      </div>

      <div className="mt-4 grid gap-4 md:grid-cols-3">
        <Input
          label="Search"
          value={searchQuery}
          onChange={onSearchChange}
          placeholder="Search by name, SKU, category, or units"
        />
        <DropdownSelect
          label="Category"
          value={categoryFilter}
          options={[
            { value: 'all', label: 'All categories' },
            ...categories.map((category) => ({
              value: category.id,
              label: category.name,
            })),
          ]}
          onChange={onCategoryChange}
        />
        <DropdownSelect
          label="Status"
          value={statusFilter}
          options={[
            { value: 'all', label: 'All statuses' },
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ]}
          onChange={(value) =>
            onStatusChange(value as 'all' | 'active' | 'inactive')
          }
        />
      </div>
    </div>
  );
}
